import React, { useContext, useEffect, useRef, useState } from "react";
import { HTTPResponse, SideMenuItems, ToastMessages, ToastMessageType, Values } from "../../Helpers/Enums";
import SideBarMenu from "../../Components/SideBarMenu";
import PatientDetails from "../../Components/PatientInformation";
import SaveAndNavigate from "../../Components/SaveAndNavigate";
import DateControl from "../../Components/DateControl";
import InfoPopUp from "../../Components/InfoPopUp";
import {
  CommonError_Msgs,
  Transplant_MMA_Related_Visit,
  Transplant_Visit,
  Transplant_MDE_Related_Visit,
  zeroToTwelve,
  zeroToThree,
  fourToFifteen,
  sixteenToTwentySeven,
} from "../../Helpers/HelperText";
import { AppContext } from "../../Contexts/AppContextProvider";
import { applySidebarState, GetLocalStorageData, GetLoggedInUserID, GetOrdinal, IsAdmin, IsDateAfter, IsDateBefore, toggleSidebar } from "../../Helpers/Utilities";
import ErrorField from "../../Components/ErrorField";
import { HospitalizationService } from "../../WebApiServices/HospitalizationService";
import CustomTextArea from "../../Components/CustomTextArea ";

const Hospitalizations = () => {
  const { ShowToast, ToggleLoader, HandleSessionTimeout, isSideMenuActive, setisSideMenuActive, appState } = useContext(AppContext);
  const navigatePaths = {
    prevPage: appState?.mdeNo > 0 ? `/MDESInformation/${appState?.mdeNo}` : "/MDESForm",
    currPage: "/Hospitalizations",
    nextPage: "/MMALabAssessment",
  };

  const pidRef = useRef(0);
  let loggedInUserId = GetLoggedInUserID();

  let dates = GetLocalStorageData("ClinicalCharacteristicsDates") || {};

  const [showTopErrMsg, setShowTopErrMsg] = useState(false);

  const [showHideHyperlinkModal, setShowHideHyperlinkModal] = useState(false);

  const [showHideHyperlinkModalMMA, setShowHideHyperlinkModalMMA] = useState(false);
  const [showHideHyperlinkModalMDE, setShowHideHyperlinkModalMDE] = useState(false);

  const [showHide012HyperlinkModal, setShowHide012HyperlinkModal] = useState(false);
  const [showHide03HyperlinkModal, setShowHide03HyperlinkModal] = useState(false);
  const [showHide415HyperlinkModal, setShowHide415HyperlinkModal] = useState(false);
  const [showHide1627HyperlinkModal, setShowHide1627HyperlinkModal] = useState(false);
   const [patientLocked, setpatientLocked] = useState(false);

  const [hospitalizationVisitsDetails, setHospitalizationVisitsDetails] = useState([
    {
      hospitalizationsid: 0,

      startVisit: "",
      start_dt: "",
      start_dt_estimated: false,
      startHospitalizationsUnkLTLKT: "",

      ongoingVisit: "",
      end_dt: "",
      end_dt_estimated: false,
      endHospitalizationsUnkLTLKT: "",

      soc: "",

      soc_hospital_reason: "",
      soc_icnicu_reason: "",
      soc_er_reason: "",
      soc_unk_reason: "",
      rvMMA: false,
      rvRenal: false,
      rvOther: false,
      rvOtherTxt: "",
      rvUnknown: false,

      q29FullEmptyError: false,

      q29StartVisitEmpty: false,
      q29EndVisitEmpty: false,
      q29SOCEmpty: false,

      startDateEmptyError: false,
      endDateEmptyError: false,

      startDateInvalid: false,
      endDateInvalid: false,

      q29StartDateUnkEmpty: false,
      q29EndDateUnkEmpty: false,


      socHospitalReasonEmpty: false,
      socICNICUReasonEmpty: false,
      socErReasonEmpty: false,
      socUnkReasonEmpty: false,

    },
  ]);


  useEffect(() => {
    async function FetchData() {
      pidRef.current = GetLocalStorageData("patientId") || 0;
      if (pidRef.current !== 0) {
        ToggleLoader(true);
        await GetHealthcareData();
        ToggleLoader(false);
      }
    }
    FetchData();

  }, [])


  const HandleFieldChange = (e) => {
    const { name, value, type, checked } = e.target;
    const splitNameArray = name.split("-");
    const fieldName = splitNameArray[0];
    const index = parseInt(splitNameArray[1], 10);

    setHospitalizationVisitsDetails((prevDetails) => {
      let updatedDetails = prevDetails.map((item, idx) => {
        if (idx === index) {
          let updatedItem = {
            ...item,
            [fieldName]: type === "checkbox" ? checked : (type === "radio" ? parseInt(value, 10) || 0 : value),
          };

          if (fieldName === "startVisit" && parseInt(value, 10) === Values.value1) {
            updatedItem.start_dt = "";
            updatedItem.start_dt_estimated = false;
            updatedItem.startHospitalizationsUnkLTLKT = "";

            updatedItem.ongoingVisit = "";
            updatedItem.end_dt = "";
            updatedItem.end_dt_estimated = false;
            updatedItem.endHospitalizationsUnkLTLKT = "";
            updatedItem.endDateInvalid = false;

            updatedItem.soc = "";
            //SYJ - new Changes - 28/03/2025 - https://edotpulse.com/EditActionItem/AG-M-164
            updatedItem.soc_hospital_reason = "";
            updatedItem.soc_icnicu_reason = "";
            updatedItem.soc_er_reason = "";
            updatedItem.soc_unk_reason = "";

            updatedItem.startDateInvalid = false;
            updatedItem.endDateEmptyError = false;

            updatedItem.q29StartVisitEmpty = false;

            updatedItem.q29EndVisitEmpty = false;
            updatedItem.q29SOCEmpty = false;

            updatedItem.startDateEmptyError = false;
            updatedItem.rvOtherEmptyError = false;

            updatedItem.endDateInvalid = false;
            updatedItem.q29StartDateUnkEmpty = false;

          } else if (fieldName === "startVisit" && parseInt(value, 10) === Values.value2) {
            updatedItem.start_dt = "";
            updatedItem.start_dt_estimated = false;
            updatedItem.startHospitalizationsUnkLTLKT = "";
            updatedItem.startDateInvalid = false;
            updatedItem.q29StartDateUnkEmpty = false;

            updatedItem.q29StartVisitEmpty = false;
            updatedItem.endDateInvalid = false;
          } else if (fieldName === "startVisit" && parseInt(value, 10) === Values.value99) {
            updatedItem.start_dt = "";
            updatedItem.start_dt_estimated = false;
            updatedItem.startHospitalizationsUnkLTLKT = "";
            updatedItem.startDateInvalid = false;

            updatedItem.q29StartVisitEmpty = false;
            updatedItem.endDateInvalid = false;
          } else if (fieldName === "startHospitalizationsUnkLTLKT") {
            updatedItem.startHospitalizationsUnkLTLKT = parseInt(value, 10);
            updatedItem.start_dt = "";
            updatedItem.start_dt_estimated = false;
            updatedItem.startVisit = 99;
            updatedItem.q29StartDateUnkEmpty = false;
            updatedItem.startDateEmptyError = false;

            updatedItem.q29StartVisitEmpty = false;
            updatedItem.startDateInvalid = false;
            updatedItem.endDateInvalid = false;
          } else if (fieldName === "start_dt_estimated") {
            updatedItem.startVisit = 2;
            updatedItem.startHospitalizationsUnkLTLKT = "";
            updatedItem.q29StartVisitEmpty = false;
            updatedItem.q29StartDateUnkEmpty = false;

          }


          if (fieldName === "ongoingVisit" && parseInt(value, 10) === Values.value1) {
            updatedItem.end_dt = "";
            updatedItem.end_dt_estimated = false;
            updatedItem.endHospitalizationsUnkLTLKT = "";
            updatedItem.q29EndDateUnkEmpty = false;

            updatedItem.q29EndVisitEmpty = false;
            updatedItem.endDateInvalid = false;
          } else if (fieldName === "ongoingVisit" && parseInt(value, 10) === Values.value2) {
            updatedItem.end_dt = "";
            updatedItem.end_dt_estimated = false;
            updatedItem.endHospitalizationsUnkLTLKT = "";
            updatedItem.q29EndVisitEmpty = false;
            updatedItem.endDateInvalid = false;
            updatedItem.q29EndDateUnkEmpty = false;
          } else if (fieldName === "ongoingVisit" && parseInt(value, 10) === Values.value99) {
            updatedItem.end_dt = "";
            updatedItem.end_dt_estimated = false;
            updatedItem.endHospitalizationsUnkLTLKT = "";
            updatedItem.q29EndVisitEmpty = false;
            updatedItem.endDateInvalid = false;
          } else if (fieldName === "endHospitalizationsUnkLTLKT") {
            updatedItem.end_dt = "";
            updatedItem.end_dt_estimated = false;
            updatedItem.ongoingVisit = 99;
            updatedItem.q29EndVisitEmpty = false;
            updatedItem.endDateInvalid = false;
            updatedItem.q29EndDateUnkEmpty = false;
            updatedItem.endDateEmptyError = false;
          }

          if (fieldName === "end_dt_estimated") {
            updatedItem.ongoingVisit = 2;
            updatedItem.endHospitalizationsUnkLTLKT = "";
            updatedItem.q29EndVisitEmpty = false;
            updatedItem.q29EndDateUnkEmpty = false;
          }



          //New changes- https://edotpulse.com/EditActionItem/AG-M-164
          if (fieldName === "soc") {
            updatedItem.q29SOCEmpty = false;

            if (parseInt(value, 10) === Values.value1) {
              updatedItem.soc_icnicu_reason = "";
              updatedItem.soc_er_reason = "";
              updatedItem.soc_unk_reason = "";
            }
            else if (parseInt(value, 10) === Values.value2) {
              updatedItem.soc_hospital_reason = "";
              updatedItem.soc_er_reason = "";
              updatedItem.soc_unk_reason = "";
            }
            else if (parseInt(value, 10) === Values.value3) {
              updatedItem.soc_hospital_reason = "";
              updatedItem.soc_icnicu_reason = "";
              updatedItem.soc_unk_reason = "";
            }
            else if (parseInt(value, 10) === Values.value99) {
              updatedItem.soc_hospital_reason = "";
              updatedItem.soc_icnicu_reason = "";
              updatedItem.soc_er_reason = "";
            }
          }

          if (fieldName === "soc_hospital_reason") {
            updatedItem.soc = 1;
            updatedItem.soc_icnicu_reason = "";
            updatedItem.soc_er_reason = "";
            updatedItem.soc_unk_reason = "";
            updatedItem.socHospitalReasonEmpty = false;
            updatedItem.socICNICUReasonEmpty = false;
            updatedItem.socErReasonEmpty = false;
            updatedItem.socUnkReasonEmpty = false;
            updatedItem.q29SOCEmpty = false;

          }

          else if (fieldName === "soc_icnicu_reason") {
            updatedItem.soc = 2;
            updatedItem.soc_hospital_reason = "";
            updatedItem.soc_er_reason = "";
            updatedItem.soc_unk_reason = "";
            updatedItem.socHospitalReasonEmpty = false;
            updatedItem.socICNICUReasonEmpty = false;
            updatedItem.socErReasonEmpty = false;
            updatedItem.socUnkReasonEmpty = false;
            updatedItem.q29SOCEmpty = false;
          }

          else if (fieldName === "soc_er_reason") {
            updatedItem.soc = 3;
            updatedItem.soc_hospital_reason = "";
            updatedItem.soc_icnicu_reason = "";
            updatedItem.soc_unk_reason = "";
            updatedItem.socHospitalReasonEmpty = false;
            updatedItem.socICNICUReasonEmpty = false;
            updatedItem.socErReasonEmpty = false;
            updatedItem.socUnkReasonEmpty = false;
            updatedItem.q29SOCEmpty = false;
          }

          else if (fieldName === "soc_unk_reason") {
            updatedItem.soc = 99;
            updatedItem.soc_hospital_reason = "";
            updatedItem.soc_icnicu_reason = "";
            updatedItem.soc_er_reason = "";
            updatedItem.socHospitalReasonEmpty = false;
            updatedItem.socICNICUReasonEmpty = false;
            updatedItem.socErReasonEmpty = false;
            updatedItem.socUnkReasonEmpty = false;
            updatedItem.q29SOCEmpty = false;
          }
          return updatedItem;
        }
        return item;
      });

      if (fieldName === "startVisit" && parseInt(value, 10) === Values.value1 && updatedDetails.length > 1) {
        updatedDetails = [updatedDetails[0]]; // Keep only the first entry
      }

      return updatedDetails;
    });
  };

  const Validate = () => {
    let isValid = true;

    let q29array = [...hospitalizationVisitsDetails];
    for (let i = 0; i < hospitalizationVisitsDetails.length; i++) {
      if (hospitalizationVisitsDetails[i].startVisit !== 1) {


        if (hospitalizationVisitsDetails[i].startVisit !== "" && hospitalizationVisitsDetails[i].startVisit !== 1 && hospitalizationVisitsDetails[i].start_dt === "" && hospitalizationVisitsDetails[i].start_dt_estimated === false
          && hospitalizationVisitsDetails[i].startHospitalizationsUnkLTLKT === "" && hospitalizationVisitsDetails[i].ongoingVisit === "" && hospitalizationVisitsDetails[i].end_dt === ""
          && hospitalizationVisitsDetails[i].end_dt_estimated === false && hospitalizationVisitsDetails[i].endHospitalizationsUnkLTLKT === "" && hospitalizationVisitsDetails[i].soc === ""
          && hospitalizationVisitsDetails[i].rvMMA === false && hospitalizationVisitsDetails[i].rvRenal === false && hospitalizationVisitsDetails[i].rvOther === false
          && hospitalizationVisitsDetails[i].rvUnknown === false
        ) {
          q29array[i].q29FullEmptyError = true;
          isValid = false;
        }

        if (hospitalizationVisitsDetails[i].startVisit === "") {
          q29array[i].q29StartVisitEmpty = true;
          isValid = false;
        }

        if (hospitalizationVisitsDetails[i].ongoingVisit === "") {
          q29array[i].q29EndVisitEmpty = true;
          isValid = false;
        }

        if (hospitalizationVisitsDetails[i].soc === "") {
          q29array[i].q29SOCEmpty = true;
          isValid = false;
        }

        if (hospitalizationVisitsDetails[i].startVisit === Values.value99 && hospitalizationVisitsDetails[i].startHospitalizationsUnkLTLKT === "") {
          q29array[i].q29StartDateUnkEmpty = true;
          isValid = false;
        }


        if (hospitalizationVisitsDetails[i].ongoingVisit === Values.value99 && hospitalizationVisitsDetails[i].endHospitalizationsUnkLTLKT === "") {
          q29array[i].q29EndDateUnkEmpty = true;
          isValid = false;
        }



        const isStartDateBefore = dates.oneYr_pretransplant_start && IsDateBefore(hospitalizationVisitsDetails[i].start_dt, dates.oneYr_pretransplant_start);
        const isStartDateAfter = dates.twenty_four_months_post_stabilization && IsDateAfter(hospitalizationVisitsDetails[i].start_dt, dates.twenty_four_months_post_stabilization);


        if (isStartDateBefore || isStartDateAfter) {
          q29array[i].startDateInvalid = true;
        }
        else {
          q29array[i].startDateInvalid = false;
        }

        const isendDateBefore = IsDateBefore(hospitalizationVisitsDetails[i].end_dt, hospitalizationVisitsDetails[i].start_dt);

        if (isendDateBefore) {
          q29array[i].endDateInvalid = true;
        }
        else {
          q29array[i].endDateInvalid = false;
        }

        //new Changes
        q29array[i].socHospitalReasonEmpty = (hospitalizationVisitsDetails[i].soc === Values.value1 && hospitalizationVisitsDetails[i].soc_hospital_reason === "") ? true : false;
        q29array[i].socICNICUReasonEmpty = (hospitalizationVisitsDetails[i].soc === Values.value2 && hospitalizationVisitsDetails[i].soc_icnicu_reason === "") ? true : false;
        q29array[i].socErReasonEmpty = (hospitalizationVisitsDetails[i].soc === Values.value3 && hospitalizationVisitsDetails[i].soc_er_reason === "") ? true : false;
        q29array[i].socUnkReasonEmpty = (hospitalizationVisitsDetails[i].soc === Values.value99 && hospitalizationVisitsDetails[i].soc_unk_reason === "") ? true : false;

        q29array[i].startDateEmptyError = (hospitalizationVisitsDetails[i].startVisit === Values.value2 && hospitalizationVisitsDetails[i].start_dt === "") ? true : false;
        q29array[i].endDateEmptyError = (hospitalizationVisitsDetails[i].ongoingVisit === Values.value2 && hospitalizationVisitsDetails[i].end_dt === "") ? true : false;

        if (q29array[i].socHospitalReasonEmpty || q29array[i].socICNICUReasonEmpty || q29array[i].socErReasonEmpty || q29array[i].socUnkReasonEmpty ||
          q29array[i].startDateEmptyError || q29array[i].endDateEmptyError || q29array[i].endDateInvalid || q29array[i].startDateInvalid) {
          isValid = false;
        }
      }
    }

    setHospitalizationVisitsDetails(q29array);

    return isValid;
  };

  const HandleDateChange = (name, date, optionId, index) => {
    let { oneYr_pretransplant_start, twenty_four_months_post_stabilization } = dates;
    const lastIndex = name.lastIndexOf("-");
    const idx = name.slice(lastIndex + 1);
    switch (optionId) {
      case "start_dt":
        {
          let Q29Admitarray = [...hospitalizationVisitsDetails];
          Q29Admitarray[idx][optionId] = date;
          Q29Admitarray[idx].startVisit = 2;
          Q29Admitarray[idx].startHospitalizationsUnkLTLKT = "";
          Q29Admitarray[idx].q29StartDateUnkEmpty = false;


          const isStartDateBefore = oneYr_pretransplant_start && IsDateBefore(date, oneYr_pretransplant_start);
          const isStartDateAfter = twenty_four_months_post_stabilization && IsDateAfter(date, twenty_four_months_post_stabilization);

          if (isStartDateBefore || isStartDateAfter) {
            Q29Admitarray[idx].startDateInvalid = true;
          }
          else {
            Q29Admitarray[idx].startDateInvalid = false;
          }

          const isendDateBefore = IsDateBefore(Q29Admitarray[idx].end_dt, date);

          if (isendDateBefore) {
            Q29Admitarray[idx].endDateInvalid = true;
          }
          else {
            Q29Admitarray[idx].endDateInvalid = false;
          }


          setHospitalizationVisitsDetails(Q29Admitarray);
        }
        break;
      case "end_dt":
        {
          let Q29Admitarray = [...hospitalizationVisitsDetails];
          Q29Admitarray[idx][optionId] = date;
          Q29Admitarray[idx].ongoingVisit = 2;
          Q29Admitarray[idx].endHospitalizationsUnkLTLKT = "";
          Q29Admitarray[idx].q29EndDateUnkEmpty = false;

          const isStartDateBefore = IsDateBefore(date, Q29Admitarray[idx].start_dt);

          if (isStartDateBefore) {
            Q29Admitarray[idx].endDateInvalid = true;
          }
          else {
            Q29Admitarray[idx].endDateInvalid = false;
          }

          setHospitalizationVisitsDetails(Q29Admitarray);
        }
        break;
      default:
        break;
    }
  };

  const GetHealthcareData = async () => {
    try {
      const response = await HospitalizationService.LoadData(pidRef.current, loggedInUserId);
      if (response?.status === HTTPResponse.OK) {
        const { data } = response;
        setpatientLocked(data.patientLocked);
        if (data.hospitalizationLoopDetails != null && data.hospitalizationLoopDetails.length > 0) {
          let i = 0;
          let dataarray = [];


          for (i; i < data.hospitalizationLoopDetails.length; i++) {
            const detailsStart = data.hospitalizationLoopDetails[i];
            const hospitalizationVisitStart = detailsStart.hospitalizationVisitStartUnknown ?? "";

            const startHospitalizationsUnkLTLKT =
              (!dates?.zero_to12months_before_LT_LKT && hospitalizationVisitStart === Values.value1) ||
                (!dates?.zero_to_3months_after_LT_LKT && hospitalizationVisitStart === Values.value2) ||
                (!dates?.four_to_15months_after_LT_LKT && hospitalizationVisitStart === Values.value3) ||
                (!dates?.sixteen_to_27months_after_LT_LKT && hospitalizationVisitStart === Values.value4)
                ? ""
                : hospitalizationVisitStart;


            const detailsEnd = data.hospitalizationLoopDetails[i];
            const hospitalizationVisitEnd = detailsEnd.hospitalizationVisitEndUnknown ?? "";

            const endHospitalizationsUnkLTLKT =
              (!dates?.zero_to12months_before_LT_LKT && hospitalizationVisitEnd === Values.value1) ||
                (!dates?.zero_to_3months_after_LT_LKT && hospitalizationVisitEnd === Values.value2) ||
                (!dates?.four_to_15months_after_LT_LKT && hospitalizationVisitEnd === Values.value3) ||
                (!dates?.sixteen_to_27months_after_LT_LKT && hospitalizationVisitEnd === Values.value4)
                ? ""
                : hospitalizationVisitEnd;

            let datacomponent = {
              hospitalizationsid: data.hospitalizationLoopDetails[i].hospitalizationsid != null
                ? data.hospitalizationLoopDetails[i].hospitalizationsid
                : 0,
              startVisit: data.hospitalizationLoopDetails[i].hospitalizationVisitStart != null
                ? data.hospitalizationLoopDetails[i].hospitalizationVisitStart
                : "",
              start_dt: data.hospitalizationLoopDetails[i].hospitalizationVisitStartDate != null
                ? data.hospitalizationLoopDetails[i].hospitalizationVisitStartDate
                : "",
              start_dt_estimated: data.hospitalizationLoopDetails[i].hospitalizationVisitStartDateEstimated != null
                ? data.hospitalizationLoopDetails[i].hospitalizationVisitStartDateEstimated
                : false,
              startHospitalizationsUnkLTLKT: startHospitalizationsUnkLTLKT,


              ongoingVisit: data.hospitalizationLoopDetails[i].hospitalizationVisitEnd != null
                ? data.hospitalizationLoopDetails[i].hospitalizationVisitEnd
                : "",
              end_dt: data.hospitalizationLoopDetails[i].hospitalizationVisitEndDate != null
                ? data.hospitalizationLoopDetails[i].hospitalizationVisitEndDate
                : "",
              end_dt_estimated: data.hospitalizationLoopDetails[i].hospitalizationVisitEndDateEstimated != null
                ? data.hospitalizationLoopDetails[i].hospitalizationVisitEndDateEstimated
                : false,
              endHospitalizationsUnkLTLKT: endHospitalizationsUnkLTLKT,

              soc: data.hospitalizationLoopDetails[i].hospitalizationSettingcare != null
                ? data.hospitalizationLoopDetails[i].hospitalizationSettingcare
                : "",


              //New Changes

              soc_hospital_reason: data.hospitalizationLoopDetails[i].hospitalizationVisitReasonTxt != null
                ? data.hospitalizationLoopDetails[i].hospitalizationVisitReasonTxt
                : "",
              soc_icnicu_reason: data.hospitalizationLoopDetails[i].icuVisitReasonTxt != null
                ? data.hospitalizationLoopDetails[i].icuVisitReasonTxt
                : "",
              soc_er_reason: data.hospitalizationLoopDetails[i].erVisitReasonTxt != null
                ? data.hospitalizationLoopDetails[i].erVisitReasonTxt
                : "",
              soc_unk_reason: data.hospitalizationLoopDetails[i].unknownVisitReasonTxt != null
                ? data.hospitalizationLoopDetails[i].unknownVisitReasonTxt
                : "",



              q29FullEmptyError: false,

              q29StartVisitEmpty: false,
              q29EndVisitEmpty: false,
              q29SOCEmpty: false,

              startDateEmptyError: false,
              endDateEmptyError: false,


              startDateInvalid: false,
              endDateInvalid: false,

              q29StartDateUnkEmpty: false,
              q29EndDateUnkEmpty: false,

              socHospitalReasonEmpty: false,
              socICNICUReasonEmpty: false,
              socErReasonEmpty: false,
              socUnkReasonEmpty: false,
            }

            dataarray.push(datacomponent);

          }
          setHospitalizationVisitsDetails(dataarray);
        }

      } else {
        if (response?.status === HTTPResponse.Unauthorized) {
          HandleSessionTimeout();
        } else {
          throw response.error;
        }
      }

    }
    catch {

    }
  }



  const SavePage = async (validate) => {
      try {
          if (!patientLocked) {
              //Reset Errors
              let isValid = validate ? Validate() : true;

              if (!isValid) {
                  setShowTopErrMsg(true);
                  return false;
              }
              setShowTopErrMsg(false);
              if (pidRef.current > 0) {
                  const data = {
                      HospitalizationModel: {
                          LoggedInUserId: loggedInUserId,
                          Patientid: pidRef.current,
                          IsValidated: validate,
                          HospitalizationLoopDetails: [],
                          IsAdmin: IsAdmin()
                      },
                  };



                  if (hospitalizationVisitsDetails.length > 0) {
                      for (const hospitalizationVisit of hospitalizationVisitsDetails) {
                          let hospitalizatioLoopData = {
                              hospitalizationsid: hospitalizationVisit.hospitalizationsid,
                              hospitalizationVisitStart: hospitalizationVisit.startVisit,
                              hospitalizationVisitStartDate: hospitalizationVisit.start_dt,
                              hospitalizationVisitStartDateEstimated: hospitalizationVisit.start_dt_estimated,
                              hospitalizationVisitStartUnknown: hospitalizationVisit.startHospitalizationsUnkLTLKT,
                              hospitalizationVisitEnd: hospitalizationVisit.ongoingVisit,
                              hospitalizationVisitEndDate: hospitalizationVisit.end_dt,
                              hospitalizationVisitEndDateEstimated: hospitalizationVisit.end_dt_estimated,
                              hospitalizationVisitEndUnknown: hospitalizationVisit.endHospitalizationsUnkLTLKT,
                              hospitalizationSettingcare: hospitalizationVisit.soc,

                              hospitalizationVisitReasonTxt: hospitalizationVisit.soc_hospital_reason,
                              icuVisitReasonTxt: hospitalizationVisit.soc_icnicu_reason,
                              erVisitReasonTxt: hospitalizationVisit.soc_er_reason,
                              unknownVisitReasonTxt: hospitalizationVisit.soc_unk_reason,


                          };
                          data.HospitalizationModel.HospitalizationLoopDetails.push(hospitalizatioLoopData);
                      }
                  }



                  ToggleLoader(true);
                  const response = await HospitalizationService.SaveData(data.HospitalizationModel);
                  ToggleLoader(false);
                  if (response.status !== HTTPResponse.OK) {
                      if (response?.status === HTTPResponse.Unauthorized) {
                          HandleSessionTimeout();
                      } else throw response.error;
                  } else {
                      ShowToast(ToastMessages.Save_Success, ToastMessageType.Success);
                      await GetHealthcareData();
                      if (response) {
                          const { data } = response;
                          if (data) {
                              SetFields(data);
                          }
                      }
                  }
              }
          }
      return true;
    } catch (error) {
      ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
    }
  };

  const SetFields = (data) => {
    if (data.hospitalizationLoopDetails != null && data.hospitalizationLoopDetails.length > 0) {
      let i = 0;
      let dataarray = [];
      for (i; i < data.hospitalizationLoopDetails.length; i++) {
        let datacomponent = {
          hospitalizationsid: data.hospitalizationLoopDetails[i].hospitalizationsid != null
            ? data.hospitalizationLoopDetails[i].hospitalizationsid
            : 0,
          startVisit: data.hospitalizationLoopDetails[i].hospitalizationVisitStart != null
            ? data.hospitalizationLoopDetails[i].hospitalizationVisitStart
            : "",
          start_dt: data.hospitalizationLoopDetails[i].hospitalizationVisitStartDate != null
            ? data.hospitalizationLoopDetails[i].hospitalizationVisitStartDate
            : "",
          start_dt_estimated: data.hospitalizationLoopDetails[i].hospitalizationVisitStartDateEstimated != null
            ? data.hospitalizationLoopDetails[i].hospitalizationVisitStartDateEstimated
            : false,
          startHospitalizationsUnkLTLKT: data.hospitalizationLoopDetails[i].hospitalizationVisitStartUnknown != null
            ? data.hospitalizationLoopDetails[i].hospitalizationVisitStartUnknown
            : "",

          ongoingVisit: data.hospitalizationLoopDetails[i].hospitalizationVisitEnd != null
            ? data.hospitalizationLoopDetails[i].hospitalizationVisitEnd
            : "",
          end_dt: data.hospitalizationLoopDetails[i].hospitalizationVisitEndDate != null
            ? data.hospitalizationLoopDetails[i].hospitalizationVisitEndDate
            : "",
          end_dt_estimated: data.hospitalizationLoopDetails[i].hospitalizationVisitEndDateEstimated != null
            ? data.hospitalizationLoopDetails[i].hospitalizationVisitEndDateEstimated
            : false,
          endHospitalizationsUnkLTLKT: data.hospitalizationLoopDetails[i].hospitalizationVisitEndUnknown != null
            ? data.hospitalizationLoopDetails[i].hospitalizationVisitEndUnknown
            : "",

          soc: data.hospitalizationLoopDetails[i].hospitalizationSettingcare != null
            ? data.hospitalizationLoopDetails[i].hospitalizationSettingcare
            : "",

          //SYJ -28/03/2025- New Changes
          soc_hospital_reason: data.hospitalizationLoopDetails[i].hospitalizationVisitReasonTxt != null
            ? data.hospitalizationLoopDetails[i].hospitalizationVisitReasonTxt
            : "",
          soc_icnicu_reason: data.hospitalizationLoopDetails[i].icuVisitReasonTxt != null
            ? data.hospitalizationLoopDetails[i].icuVisitReasonTxt
            : "",
          soc_er_reason: data.hospitalizationLoopDetails[i].erVisitReasonTxt != null
            ? data.hospitalizationLoopDetails[i].erVisitReasonTxt
            : "",
          soc_unk_reason: data.hospitalizationLoopDetails[i].unknownVisitReasonTxt != null
            ? data.hospitalizationLoopDetails[i].unknownVisitReasonTxt
            : "",



          q29FullEmptyError: false,

          q29StartVisitEmpty: false,
          q29EndVisitEmpty: false,
          q29SOCEmpty: false,

          startDateEmptyError: false,
          endDateEmptyError: false,

          startDateInvalid: false,
          endDateInvalid: false,

          q29StartDateUnkEmpty: false,
          q29EndDateUnkEmpty: false,

          socHospitalReasonEmpty: false,
          socICNICUReasonEmpty: false,
          socErReasonEmpty: false,
          socUnkReasonEmpty: false,
        }

        dataarray.push(datacomponent);

      }
      setHospitalizationVisitsDetails(dataarray);
    }
  }

  useEffect(() => {
    applySidebarState(isSideMenuActive);
  }, [isSideMenuActive]);



  function addHospitalizationVisitRow(e) {
    setHospitalizationVisitsDetails((prev) => [
      ...prev,
      {
        hospitalizationsid: 0,

        startVisit: "",
        start_dt: "",
        start_dt_estimated: false,
        startHospitalizationsUnkLTLKT: "",

        ongoingVisit: "",
        end_dt: "",
        end_dt_estimated: false,
        endHospitalizationsUnkLTLKT: "",

        soc: "",

        //SYJ - New Changes options added.
        soc_hospital_reason: "",
        soc_icnicu_reason: "",
        soc_er_reason: "",
        soc_unk_reason: "",


        rvMMA: false,
        rvRenal: false,
        rvOther: false,
        rvOtherTxt: "",
        rvUnknown: false,

        q29FullEmptyError: false,

        q29StartVisitEmpty: false,
        q29EndVisitEmpty: false,
        q29SOCEmpty: false,

        startDateEmptyError: false,
        endDateEmptyError: false,

        startDateInvalid: false,
        endDateInvalid: false,

        q29StartDateUnkEmpty: false,
        q29EndDateUnkEmpty: false,


        socHospitalReasonEmpty: false,
        socICNICUReasonEmpty: false,
        socErReasonEmpty: false,
        socUnkReasonEmpty: false,
      },
    ]);
  }

  function deleteHospitalizationVisitDetails(id) {
    const newHospitalizationVisitDetailsArray = [...hospitalizationVisitsDetails];
    newHospitalizationVisitDetailsArray.splice(id, 1);
    setHospitalizationVisitsDetails(newHospitalizationVisitDetailsArray);
  }

  return (
    <>
      <section className="survey-patient-details-section">
        <div className="row">
          <PatientDetails />
          <div className="col-12 col-sm-5 col-md-5 col-lg-6 col-content-alignment">
            <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
          </div>
        </div>
      </section>

      <section className="main-survey-section main-survey-button">
        <div >
          <SideBarMenu activePageId={SideMenuItems.Hospitalizations} />
          <>
            <button className={isSideMenuActive ? "openbtn" : "openbtn active"}
              onClick={() => toggleSidebar(isSideMenuActive, setisSideMenuActive)}
            >
              <i
                id="arrowNavigation"
                className="fa fa-arrow-left"
                aria-hidden="true"
              ></i>
            </button>
          </>
          <div className="col-pad-left eligibiltylocked" id="main">
            <div className="survey-section-content" id="contentsec">
              <div className="survey-section-content-header">
                <h4>HOSPITALIZATIONS</h4>
              </div>
              {showTopErrMsg && (
                <div className="clean-error ">
                  <ErrorField
                    show={showTopErrMsg}
                    message={CommonError_Msgs.Hard_Empty}
                  />
                </div>
              )}
              {/* <summary>
              date: 23-12-2024
              Name: ST
              description: Hospitalizations Design
              <summary> */}
              <div className="survey-question-section" disabled={patientLocked}>
                <div className="survey-question-content survey-content-box grey-bg">
                  <div className="question-answer grid-overflow">
                    {/* Q35. */}
                    <table
                      cellPadding="0"
                      cellSpacing="0"
                      border="0"
                      width="100%"
                    >
                      <tr>
                        <td className="">
                          {/* mainContent */}
                          <table
                            cellPadding="0"
                            cellSpacing="0"
                            width="100%"
                            border="1"
                            className="borderTable"
                          >
                            <tr>
                              <td className="containertd">
                                <div className="question question-weight">
                                  <span>Q29.</span>
                                  <span className="quest-text-pad">
                                    Please report{" "}
                                    <u>
                                      all <span
                                        data-tooltip-id="encounterTip"
                                        className="modal-popup"
                                        onClick={() =>
                                          setShowHideHyperlinkModalMMA(true)
                                        }
                                      >other MMA-related visits</span>
                                    </u>
                                    {showHideHyperlinkModalMMA && (
                                      <InfoPopUp
                                        description={Transplant_MMA_Related_Visit}
                                        OkClick={() =>
                                          setShowHideHyperlinkModalMMA(false)
                                        }
                                      />
                                    )}
                                    , including any hospitalizations, ICU/NICU visits, or ER visits, that occurred outside of an MDE within the patient’s chart within 12 months prior to and 27 months after the index date (from{" "}


                                    <span className="indigo-text">
                                      {dates?.oneYr_pretransplant_start != null ? dates?.oneYr_pretransplant_start : "[1-year pre-transplant start]"}
                                    </span>
                                    {" "}to{" "}
                                    <span className="indigo-text">
                                      {dates?.twenty_four_months_post_stabilization != null ? dates?.twenty_four_months_post_stabilization : " [24-month post-stabilization date]"}
                                    </span>



                                    )

                                    <br />

                                    Please ensure that:
                                    <br />
                                    <ul className="important-note-list margin-align">
                                      <p className="important-note-item">
                                        No <span
                                          data-tooltip-id="encounterTip"
                                          className="modal-popup"
                                          onClick={() =>
                                            setShowHideHyperlinkModal(true)
                                          }
                                        >transplant-related visits</span> previously reported in <span className="indigo-text"><b>Q24</b></span> are included in the rows below
                                      </p>
                                      {showHideHyperlinkModal && (
                                        <InfoPopUp
                                          description={Transplant_Visit}
                                          OkClick={() =>
                                            setShowHideHyperlinkModal(false)
                                          }
                                        />
                                      )}{" "}
                                      <p className="important-note-item">
                                        No <span
                                          data-tooltip-id="encounterTip"
                                          className="modal-popup"
                                          onClick={() =>
                                            setShowHideHyperlinkModalMDE(true)
                                          }
                                        >MDE-related visits</span> previously reported in <span className="indigo-text"><b>Q28.1</b></span> are included in the rows below
                                      </p>
                                      {showHideHyperlinkModalMDE && (
                                        <InfoPopUp
                                          description={Transplant_MDE_Related_Visit}
                                          OkClick={() =>
                                            setShowHideHyperlinkModalMDE(false)
                                          }
                                        />
                                      )}{" "}
                                      <p className="important-note-item">
                                    All hospitalizations are related to the patient's MMA-related disease status (please include any exacerbated signs and symptoms, treatments, or procedures received during the hospitalization to provide context for the MMA-related visit) 
                                    </p>


                                      <p className="important-note-item">
                                        Only non-transplant-related hospitalizations, ER visits, or ICU/NICU visits for treatment of a complication or manifestation of MMA (and not resulting in an MDE) are included in the rows below
                                      </p>
                                      <p className="important-note-item">
                                        If multiple care settings occurred (e.g., patient transferred from ER to hospital, etc.), please <u> list each care setting as an individual row with start and end dates specific for that setting of care</u>
                                      </p>
                                    </ul>
                                  </span>
                                </div>
                                Add additional rows for each hospitalization, ICU/NICU visit, or ER visit, as needed.
                              </td>
                            </tr>
                            <div className="block-margin white-bg" style={{ marginBlock: "20px 0", padding: "8px" }}>
                              {
                                hospitalizationVisitsDetails.length > 0 ? (hospitalizationVisitsDetails.map((data, idx) => (
                                  <div className="loop-section-ul" key={data.hospitalizationsid}>
                                    <div className="loop-head">
                                      <span className="question-weight">
                                        {GetOrdinal(idx + 1)} Visit
                                      </span>
                                      {idx != 0 && (
                                        <div className="delete-btn-div">
                                          <img
                                            width="16px"
                                            src="../Assets/images/Icon-material-delete.png"
                                            alt=""
                                            onClick={() =>
                                              deleteHospitalizationVisitDetails(idx)
                                            }
                                          />
                                        </div>
                                      )}
                                    </div>
                                    <tr>
                                      <td style={{ padding: "15px", border: "none" }} >
                                        <table className="custom-child-table white-bg" border="1"
                                        >
                                          <thead>
                                            <tr>
                                              <th className="modal-popup-table-header-cell" style={{
                                                borderRight: "1px solid",
                                                borderColor: "inherit",
                                                padding: "8px",
                                                textAlign: "center",
                                                minWidth: "320px",
                                              }}>
                                                Start date of visit
                                              </th>
                                              <th className="modal-popup-table-header-cell" style={{
                                                borderRight: "1px solid",
                                                borderColor: "inherit",
                                                padding: "8px",
                                                textAlign: "center",
                                                minWidth: "320px",
                                              }}>
                                                End date of visit
                                              </th>
                                              <th className="modal-popup-table-header-cell" style={{
                                                borderRight: "1px solid",
                                                borderColor: "inherit",
                                                padding: "8px",
                                                textAlign: "center",
                                                minWidth: "300px",
                                              }}>
                                                Setting of care and reason for visit (e.g., MMA-related signs/symptoms, treatments, etc.)
                                              </th>

                                            </tr>
                                          </thead>

                                          <tbody
                                            key={data.hospitalizationsid}>
                                            <tr>
                                              <td className="modal-popup-table-cell">
                                                {idx === 0 &&
                                                  <div className="date-field-padding">
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={"startVisit-" + idx}
                                                        value={1}
                                                        checked={data.startVisit === Values.value1}
                                                        onChange={HandleFieldChange}
                                                      />
                                                      <span className="">
                                                        No visits occurred during period
                                                      </span>
                                                    </label>
                                                  </div>
                                                }
                                                <div className="date-field-padding">
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={"startVisit-" + idx}
                                                      value={2}
                                                      checked={data.startVisit === Values.value2}
                                                      onChange={HandleFieldChange}
                                                    />

                                                    <span className="">

                                                      <DateControl
                                                        optionId={"start_dt"}
                                                        ctrlId={"start_dt-" + idx}
                                                        HandleDateChange={HandleDateChange}
                                                        date={data.start_dt}
                                                      />
                                                    </span>
                                                  </label>
                                                </div>
                                                <div className="estimated-date-padding text-margin">
                                                  <label>
                                                    <input
                                                      type="checkbox"
                                                      id={idx}
                                                      name={"start_dt_estimated-" + idx}
                                                      checked={data.start_dt_estimated}
                                                      onChange={HandleFieldChange}
                                                    />
                                                    <span className="radio-text-padding">
                                                      Estimated Date
                                                    </span>
                                                  </label>
                                                </div>
                                                <div className="date-field-padding">
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={"startVisit-" + idx}
                                                      value={99}
                                                      checked={data.startVisit === Values.value99}
                                                      onChange={HandleFieldChange}
                                                    />
                                                    <span className="">
                                                      Date unknown
                                                    </span>
                                                  </label>
                                                  <div style={{ marginLeft: "30px" }}>
                                                    {dates?.zero_to12months_before_LT_LKT !== null && dates?.zero_to12months_before_LT_LKT &&
                                                      <div>
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={"startHospitalizationsUnkLTLKT-" + idx}
                                                            value={1}
                                                            checked={data.startHospitalizationsUnkLTLKT === Values.value1}
                                                            onChange={HandleFieldChange}
                                                          />
                                                          <span
                                                            data-tooltip-id="encounterTip"
                                                            className="modal-popup"
                                                            onClick={() =>
                                                              setShowHide012HyperlinkModal(true)
                                                            }
                                                          >
                                                            0 to 12 months before LT/LKT
                                                          </span>


                                                        </label>
                                                      </div>}
                                                    {dates?.zero_to_3months_after_LT_LKT !== null && dates?.zero_to_3months_after_LT_LKT &&
                                                      <div>
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={"startHospitalizationsUnkLTLKT-" + idx}
                                                            value={2}
                                                            checked={data.startHospitalizationsUnkLTLKT === Values.value2}
                                                            onChange={HandleFieldChange}
                                                          />
                                                          <span
                                                            data-tooltip-id="encounterTip"
                                                            className="modal-popup"
                                                            onClick={() =>
                                                              setShowHide03HyperlinkModal(true)
                                                            }
                                                          >
                                                            0 to 3 months after LT/LKT
                                                          </span>

                                                        </label>
                                                      </div>}
                                                    {dates?.four_to_15months_after_LT_LKT !== null && dates?.four_to_15months_after_LT_LKT &&
                                                      <div>
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={"startHospitalizationsUnkLTLKT-" + idx}
                                                            value={3}
                                                            checked={data.startHospitalizationsUnkLTLKT === Values.value3}
                                                            onChange={HandleFieldChange}
                                                          />
                                                          <span
                                                            data-tooltip-id="encounterTip"
                                                            className="modal-popup"
                                                            onClick={() =>
                                                              setShowHide415HyperlinkModal(true)
                                                            }
                                                          >
                                                            4 to 15 months after LT/LKT
                                                          </span>


                                                        </label>
                                                      </div>}
                                                    {dates?.sixteen_to_27months_after_LT_LKT !== null && dates?.sixteen_to_27months_after_LT_LKT &&
                                                      <div>
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={"startHospitalizationsUnkLTLKT-" + idx}
                                                            value={4}
                                                            checked={data.startHospitalizationsUnkLTLKT === Values.value4}
                                                            onChange={HandleFieldChange}
                                                          />
                                                          <span
                                                            data-tooltip-id="encounterTip"
                                                            className="modal-popup"
                                                            onClick={() =>
                                                              setShowHide1627HyperlinkModal(true)
                                                            }
                                                          >
                                                            16 to 27 months after LT/LKT
                                                          </span>

                                                        </label>
                                                      </div>}
                                                    <div>
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={"startHospitalizationsUnkLTLKT-" + idx}
                                                          value={5}
                                                          checked={data.startHospitalizationsUnkLTLKT === Values.value5}
                                                          onChange={HandleFieldChange}
                                                        />
                                                        <span className="">
                                                          Date completely unknown
                                                        </span>
                                                      </label>
                                                    </div>
                                                  </div>
                                                </div>

                                                <ErrorField
                                                  show={data.startDateEmptyError}
                                                  message={CommonError_Msgs.Msg2}
                                                />

                                                <ErrorField
                                                  show={data.q29StartDateUnkEmpty}
                                                  message={CommonError_Msgs.Msg1}
                                                />

                                                <ErrorField
                                                  show={data.q29StartVisitEmpty}
                                                  message={CommonError_Msgs.Msg1}
                                                />

                                                <ErrorField
                                                  show={data.startDateInvalid}
                                                  message={CommonError_Msgs.Msg2}
                                                />
                                              </td>

                                              {data.startVisit === Values.value1 ? (
                                                <td
                                                  className="containertd"
                                                  style={{
                                                    textAlign: "center",
                                                    borderRight: "0",
                                                  }}
                                                >
                                                  <span
                                                    style={{ textAlign: "center" }}
                                                    className="not-applicable"
                                                  >
                                                    <b>Not Applicable</b>
                                                  </span>
                                                </td>
                                              ) : (
                                                <td className="modal-popup-table-cell">
                                                  <div className="date-field-padding">
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={"ongoingVisit-" + idx}
                                                        value={1}
                                                        checked={data.ongoingVisit === Values.value1}
                                                        onChange={HandleFieldChange}
                                                      />
                                                      <span className="">
                                                        Visit is ongoing
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div className="date-field-padding">
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={"ongoingVisit-" + idx}
                                                        value={2}
                                                        checked={data.ongoingVisit === Values.value2}
                                                        onChange={HandleFieldChange}
                                                      />

                                                      <span className="">
                                                        <DateControl
                                                          optionId={"end_dt"}
                                                          ctrlId={"end_dt-" + idx}
                                                          HandleDateChange={HandleDateChange}
                                                          date={data.end_dt}
                                                        />
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div className="estimated-date-padding text-margin">
                                                    <label>
                                                      <input
                                                        type="checkbox"
                                                        id={idx}
                                                        name={"end_dt_estimated-" + idx}
                                                        checked={data.end_dt_estimated}
                                                        onChange={HandleFieldChange}
                                                      />
                                                      <span className="radio-text-padding">
                                                        Estimated Date
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div className="date-field-padding">
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={"ongoingVisit-" + idx}
                                                        value={99}
                                                        checked={data.ongoingVisit === Values.value99}
                                                        onChange={HandleFieldChange}
                                                      />
                                                      <span className="">
                                                        Date unknown
                                                      </span>
                                                    </label>
                                                    <div style={{ marginLeft: "30px" }}>
                                                      {dates?.zero_to12months_before_LT_LKT !== null && dates?.zero_to12months_before_LT_LKT &&
                                                        <div>
                                                          <label className="option-fbox">
                                                            <input
                                                              type="radio"
                                                              id={idx}
                                                              name={"endHospitalizationsUnkLTLKT-" + idx}
                                                              value={1}
                                                              checked={data.endHospitalizationsUnkLTLKT === Values.value1}
                                                              onChange={HandleFieldChange}
                                                            />
                                                            <span
                                                              data-tooltip-id="encounterTip"
                                                              className="modal-popup"
                                                              onClick={() =>
                                                                setShowHide012HyperlinkModal(true)
                                                              }
                                                            >
                                                              0 to 12 months before LT/LKT
                                                            </span>

                                                          </label>
                                                        </div>}
                                                      {dates?.zero_to_3months_after_LT_LKT !== null && dates?.zero_to_3months_after_LT_LKT &&
                                                        <div>
                                                          <label className="option-fbox">
                                                            <input
                                                              type="radio"
                                                              id={idx}
                                                              name={"endHospitalizationsUnkLTLKT-" + idx}
                                                              value={2}
                                                              checked={data.endHospitalizationsUnkLTLKT === Values.value2}
                                                              onChange={HandleFieldChange}
                                                            />
                                                            <span
                                                              data-tooltip-id="encounterTip"
                                                              className="modal-popup"
                                                              onClick={() =>
                                                                setShowHide03HyperlinkModal(true)
                                                              }
                                                            >
                                                              0 to 3 months after LT/LKT
                                                            </span>

                                                          </label>
                                                        </div>}
                                                      {dates?.four_to_15months_after_LT_LKT !== null && dates?.four_to_15months_after_LT_LKT &&
                                                        <div>
                                                          <label className="option-fbox">
                                                            <input
                                                              type="radio"
                                                              id={idx}
                                                              name={"endHospitalizationsUnkLTLKT-" + idx}
                                                              value={3}
                                                              checked={data.endHospitalizationsUnkLTLKT === Values.value3}
                                                              onChange={HandleFieldChange}
                                                            />
                                                            <span
                                                              data-tooltip-id="encounterTip"
                                                              className="modal-popup"
                                                              onClick={() =>
                                                                setShowHide415HyperlinkModal(true)
                                                              }
                                                            >
                                                              4 to 15 months after LT/LKT
                                                            </span>

                                                          </label>
                                                        </div>}
                                                      {dates?.sixteen_to_27months_after_LT_LKT !== null && dates?.sixteen_to_27months_after_LT_LKT &&
                                                        <div>
                                                          <label className="option-fbox">
                                                            <input
                                                              type="radio"
                                                              id={idx}
                                                              name={"endHospitalizationsUnkLTLKT-" + idx}
                                                              value={4}
                                                              checked={data.endHospitalizationsUnkLTLKT === Values.value4}
                                                              onChange={HandleFieldChange}
                                                            />
                                                            <span
                                                              data-tooltip-id="encounterTip"
                                                              className="modal-popup"
                                                              onClick={() =>
                                                                setShowHide1627HyperlinkModal(true)
                                                              }
                                                            >
                                                              16 to 27 months after LT/LKT
                                                            </span>

                                                          </label>
                                                        </div>}
                                                      <div>
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={"endHospitalizationsUnkLTLKT-" + idx}
                                                            value={5}
                                                            checked={data.endHospitalizationsUnkLTLKT === Values.value5}
                                                            onChange={HandleFieldChange}
                                                          />
                                                          <span className="">
                                                            Date completely unknown
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>

                                                  <ErrorField
                                                    show={data.endDateEmptyError}
                                                    message={CommonError_Msgs.Msg2}
                                                  />


                                                  <ErrorField
                                                    show={data.q29EndDateUnkEmpty}
                                                    message={CommonError_Msgs.Msg1}
                                                  />

                                                  <ErrorField
                                                    show={data.q29EndVisitEmpty}
                                                    message={CommonError_Msgs.Msg1}
                                                  />

                                                  <ErrorField
                                                    show={data.endDateInvalid}
                                                    message={CommonError_Msgs.Msg2}
                                                  />
                                                </td>)}


                                              {data.startVisit === Values.value1 ? (
                                                <td
                                                  className="containertd"
                                                  style={{
                                                    textAlign: "center",
                                                    borderRight: "0",
                                                  }}
                                                >
                                                  <span
                                                    style={{ textAlign: "center" }}
                                                    className="not-applicable"
                                                  >
                                                    <b>Not Applicable</b>
                                                  </span>
                                                </td>
                                              ) : (
                                                <td className="modal-popup-table-cell">
                                                  <div className="date-field-padding">
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={"soc-" + idx}
                                                        value={1}
                                                        checked={data.soc === Values.value1}
                                                        onChange={HandleFieldChange}
                                                      />
                                                      <span
                                                        className=""
                                                        style={{ textWrap: "nowrap" }}
                                                      >
                                                        Hospitalization
                                                      </span>
                                                    </label>

                                                    <label className="option-fbox" style={{ marginLeft: "40px" }}>
                                                      <span
                                                        className=""
                                                        style={{ textWrap: "nowrap" }}
                                                      >
                                                        Reason for visit:
                                                      </span>
                                                      {/* <input
                                                        className="input-dash"
                                                        type="text"
                                                        id={idx}
                                                        name={"soc_hospital_reason-" + idx}
                                                        maxLength={300}
                                                        value={data.soc_hospital_reason}
                                                        onChange={HandleFieldChange}
                                                        style={{ width: "60%" }}
                                                      /> */}
                                                    </label>
                                                    <CustomTextArea
                                                      id={idx}
                                                      name={"soc_hospital_reason-" + idx}
                                                      value={data.soc_hospital_reason}
                                                      onChange={HandleFieldChange}
                                                      styles={{ marginLeft: "30px", width: "90%" }}
                                                    />

                                                  </div>
                                                  <div className="date-field-padding">
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={"soc-" + idx}
                                                        value={2}
                                                        checked={data.soc === Values.value2}
                                                        onChange={HandleFieldChange}
                                                      />
                                                      <span
                                                        className=""
                                                        style={{ textWrap: "nowrap" }}
                                                      >
                                                        ICU/NICU visit
                                                      </span>
                                                    </label>
                                                    <label className="option-fbox" style={{ marginLeft: "40px" }}>
                                                      <span
                                                        className=""
                                                        style={{ textWrap: "nowrap" }}
                                                      >
                                                        Reason for visit:
                                                      </span>


                                                    </label>
                                                    <CustomTextArea
                                                      id={idx}
                                                      name={"soc_icnicu_reason-" + idx}
                                                      value={data.soc_icnicu_reason}
                                                      onChange={HandleFieldChange}
                                                      styles={{ marginLeft: "30px", width: "90%" }}
                                                    />
                                                  </div>
                                                  <div className="date-field-padding">
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={"soc-" + idx}
                                                        value={3}
                                                        checked={data.soc === Values.value3}
                                                        onChange={HandleFieldChange}
                                                      />
                                                      <span
                                                        className=""
                                                        style={{ textWrap: "nowrap" }}
                                                      >
                                                        ER visit
                                                      </span>
                                                    </label>
                                                    <label className="option-fbox" style={{ marginLeft: "40px" }}>
                                                      <span
                                                        className=""
                                                        style={{ textWrap: "nowrap" }}
                                                      >
                                                        Reason for visit:
                                                      </span>


                                                    </label>
                                                    <CustomTextArea
                                                      id={idx}
                                                      name={"soc_er_reason-" + idx}
                                                      value={data.soc_er_reason}
                                                      onChange={HandleFieldChange}
                                                      styles={{ marginLeft: "30px", width: "90%" }}
                                                    />
                                                  </div>

                                                  <div className="date-field-padding" style={{ paddingBottom: "10px" }}>
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={"soc-" + idx}
                                                        value={99}
                                                        checked={data.soc === Values.value99}
                                                        onChange={HandleFieldChange}
                                                      />
                                                      <span
                                                        className=""
                                                        style={{ textWrap: "nowrap" }}
                                                      >
                                                        Unknown
                                                      </span>
                                                    </label>
                                                    <label className="option-fbox" style={{ marginLeft: "40px" }}>
                                                      <span
                                                        className=""
                                                        style={{ textWrap: "nowrap" }}
                                                      >
                                                        Reason for visit:
                                                      </span>


                                                    </label>
                                                    <CustomTextArea
                                                      id={idx}
                                                      name={"soc_unk_reason-" + idx}
                                                      value={data.soc_unk_reason}
                                                      onChange={HandleFieldChange}
                                                      styles={{ marginLeft: "30px", width: "90%" }}
                                                    />
                                                  </div>

                                                  <ErrorField
                                                    show={data.socHospitalReasonEmpty}
                                                    message={CommonError_Msgs.Msg1}
                                                  />

                                                  <ErrorField
                                                    show={data.socICNICUReasonEmpty}
                                                    message={CommonError_Msgs.Msg1}
                                                  />

                                                  <ErrorField
                                                    show={data.socErReasonEmpty}
                                                    message={CommonError_Msgs.Msg1}
                                                  />

                                                  <ErrorField
                                                    show={data.socUnkReasonEmpty}
                                                    message={CommonError_Msgs.Msg1}
                                                  />

                                                  <ErrorField
                                                    show={data.q29SOCEmpty}
                                                    message={CommonError_Msgs.Msg1}
                                                  />
                                                </td>)}


                                            </tr>
                                          </tbody>

                                        </table>
                                      </td>
                                    </tr>
                                  </div>))) : (<></>)
                              }</div>
                            {
                              hospitalizationVisitsDetails && hospitalizationVisitsDetails[0].startVisit !== Values.value1 && patientLocked===false &&
                              <div className="answer-list-text" onClick={addHospitalizationVisitRow} style={{ width: "fit-content", marginLeft: "5px", marginBottom: "5px" }}>
                                <a>
                                  <img width="18px" src="../Assets/images/plus.png" alt="" />
                                </a>
                                <a className="radio-text-padding">
                                  Click here to add another visit
                                </a>
                              </div>}
                          </table>
                        </td>
                      </tr>
                    </table>

                  </div>
                </div>
              </div>

              <div className="survey-section-content-foot">
                <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
              </div>
            </div>
          </div>
        </div>
      </section>
      {showHide012HyperlinkModal && (
        <InfoPopUp
          description={zeroToTwelve(dates?.oneYr_pretransplant_start, dates?.oneYr_pretransplant_end)}
          OkClick={() =>
            setShowHide012HyperlinkModal(false)
          }
        />
      )}
      {showHide03HyperlinkModal && (
        <InfoPopUp
          description={zeroToThree(dates?.indexDt, dates?.three_month_stabilization)}
          OkClick={() =>
            setShowHide03HyperlinkModal(false)
          }
        />
      )}
      {showHide415HyperlinkModal && (
        <InfoPopUp
          description={fourToFifteen(dates?.post_stabilization_start, dates?.twelve_month_post_stabilization)}
          OkClick={() =>
            setShowHide415HyperlinkModal(false)
          }
        />
      )}
      {showHide1627HyperlinkModal && (
        <InfoPopUp
          description={sixteenToTwentySeven(dates?.twelve_month_post_stabilization_plusOneday, dates?.twenty_four_months_post_stabilization)}
          OkClick={() =>
            setShowHide1627HyperlinkModal(false)
          }
        />
      )}
    </>
  );
};

export default Hospitalizations;
